/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ValidateTokenResponse } from './ValidateTokenResponse';
import {
    ValidateTokenResponseFromJSON,
    ValidateTokenResponseFromJSONTyped,
    ValidateTokenResponseToJSON,
    ValidateTokenResponseToJSONTyped,
} from './ValidateTokenResponse';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
    APIResponseErrorToJSONTyped,
} from './APIResponseError';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
    APIMetaToJSONTyped,
} from './APIMeta';

/**
 * 
 * @export
 * @interface PostTokenValidate200Response
 */
export interface PostTokenValidate200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostTokenValidate200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostTokenValidate200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {ValidateTokenResponse}
     * @memberof PostTokenValidate200Response
     */
    result?: ValidateTokenResponse;
}

/**
 * Check if a given object implements the PostTokenValidate200Response interface.
 */
export function instanceOfPostTokenValidate200Response(value: object): value is PostTokenValidate200Response {
    return true;
}

export function PostTokenValidate200ResponseFromJSON(json: any): PostTokenValidate200Response {
    return PostTokenValidate200ResponseFromJSONTyped(json, false);
}

export function PostTokenValidate200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostTokenValidate200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'meta': json['meta'] == null ? undefined : APIMetaFromJSON(json['meta']),
        'errors': json['errors'] == null ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': json['result'] == null ? undefined : ValidateTokenResponseFromJSON(json['result']),
    };
}

export function PostTokenValidate200ResponseToJSON(json: any): PostTokenValidate200Response {
    return PostTokenValidate200ResponseToJSONTyped(json, false);
}

export function PostTokenValidate200ResponseToJSONTyped(value?: PostTokenValidate200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'meta': APIMetaToJSON(value['meta']),
        'errors': value['errors'] == null ? undefined : ((value['errors'] as Array<any>).map(APIResponseErrorToJSON)),
        'result': ValidateTokenResponseToJSON(value['result']),
    };
}

